/** Small seeded helpers shared by the generators. */

import type { Pcg32 } from '../sim/rng';

/** Fisher-Yates on a copy. */
export function shuffled<T>(rng: Pcg32, items: readonly T[]): T[] {
  const out = [...items];
  for (let i = out.length - 1; i > 0; i--) {
    const j = rng.int(i + 1);
    const a = out[i] as T;
    out[i] = out[j] as T;
    out[j] = a;
  }
  return out;
}

/** Pick by relative weight. */
export function weighted<T>(rng: Pcg32, entries: ReadonlyArray<readonly [T, number]>): T {
  let total = 0;
  for (const [, w] of entries) total += w;
  let roll = rng.float() * total;
  for (const [item, w] of entries) {
    roll -= w;
    if (roll < 0) return item;
  }
  const last = entries[entries.length - 1];
  if (!last) throw new RangeError('weighted: no entries');
  return last[0];
}

export function round2(v: number): number {
  return Math.round(v * 100) / 100;
}

/** Fill `{key}` placeholders. */
export function fillTemplate(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (whole, key: string) => (key in values ? String(values[key]) : whole));
}
